import { Injectable } from '@angular/core';
import { CanLoad, Route, Router, UrlSegment, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { storageKeys } from 'src/app/enum/storage-keys';
import { CurrentPlatformService } from 'src/app/services/current-platform/current-platform.service';
import { StorageService } from '../../services/storage/storage.service';

@Injectable({
  providedIn: 'root'
})
export class GuidesGuard implements CanLoad {
  constructor(
    private storage: StorageService,
    private router: Router,
    private currentPlatformService: CurrentPlatformService
  ){}


  canLoad(
    route: Route,
    segments: UrlSegment[]): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

      // Dont show guide slides on browser.
    if(this.currentPlatformService.isBrowser()) return true;
    return this.storage.getStorage(storageKeys.GUIDES_ISDISPLAYED).then(result => {
      if(result && result.value) return true
      else {
        this.router.navigateByUrl('/guide-slides');
        return false;
      }
    }).catch(e => {
      console.log(e);

      this.router.navigateByUrl('/guide-slides');
      return false;
    });
  }
}
